import { render, staticRenderFns } from "./StändeView.vue?vue&type=template&id=b97dfd0e&scoped=true&"
import script from "./StändeView.vue?vue&type=script&lang=js&"
export * from "./StändeView.vue?vue&type=script&lang=js&"
import style0 from "./StändeView.vue?vue&type=style&index=0&id=b97dfd0e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b97dfd0e",
  null
  
)

export default component.exports